<div class="bg-primary checkbox-container">
  <div class="form-check">
    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" [(ngModel)]="isChecked" />
    <label class="form-check-label text-white font-size-14 mb-0" for="flexCheckDefault">
      {{ 'opt.out.description' | translate }}
    </label>
  </div>

  <ng-container *ngIf="isChecked">
    <div class="contact-us-box border">
      <div class="text-white font-size-14 mb-4">
        {{ 'opt.out.description.message' | translate }}
      </div>
      <div class="">
        <form [formGroup]="contactUsForm" validate (ngSubmit)="submit(contactUsForm.value, contactUsForm.valid)">
          <div>
            <div class="contact-title-text mt-2 mb-1">
              {{ 'contact.us.message' | translate }}
            </div>
            <textarea class="input-group contact-us-input-group h-200" formControlName="message"></textarea>
            <div class="alert alert-danger bg-primary text-white">
              <ng-container *ngIf="submitted && f.message.errors && !sentSuccessfully">
                <div *ngIf="f.message.errors.required">
                  {{ 'contact.us.message.error' | translate }}
                </div>
              </ng-container>
              <ng-container *ngIf="f.message.errors && !sentSuccessfully">
                <div *ngIf="f.message.errors.whitespace">
                  {{ 'contact.us.message.whitespace' | translate }}
                </div>
                <div *ngIf="f.message.errors.invalidTags || f.message.errors.profanityFilter">
                  {{ 'contact.us.message.invalid.data' | translate }}
                </div>
              </ng-container>
            </div>
          </div>
          <button
            class="contact-us-send-button d-block ms-auto me-auto mt-4 mb-2 border-0"
            type="submit"
            [disabled]="sentSuccessfully || !contactUsForm?.valid"
          >
            {{ 'contact.us.submit' | translate }}
          </button>
          <div class="success-message text-center" *ngIf="sentSuccessfully">
            {{ 'contact.us.submit.success' | translate }}
          </div>
        </form>
      </div>
    </div>
  </ng-container>
</div>
